import { api } from './api';

// GET all drivers (table/minimal info)
export const getDrivers = () => api.get('/admin/drivers');

// GET full driver details
export const getDriverDetails = (id: number) => api.get(`/admin/driver/${id}`);

// UPDATE driver (editable fields - including suspend/activate)
export const updateDriver = (id: number, data: any) => api.patch(`/admin/driver/${id}`, data);

// APPROVE driver
export const approveDriver = (id: number, data: any) => api.patch(`/admin/driver/approve/${id}`, data);

// SUSPEND a driver (generic PATCH)
export const suspendDriver = (id: number) =>
    api.patch(`/admin/driver/${id}`, { isAvailable: false, isDeleted: false }); // Or also update User.suspended if needed

// ACTIVATE a driver (generic PATCH)
export const activateDriver = (id: number) =>
    api.patch(`/admin/driver/${id}`, { isAvailable: true, isDeleted: false });

// DELETE a driver
export const deleteDriver = (id: number) => api.delete(`/admin/driver/${id}`);

// Get a signed (secure, temporary) URL to download an image
export const getSignedDriverDocUrl = async (s3Key?: string | null): Promise<string> => {
    if (!s3Key) return "";
    try {
        const res = await api.get(`/admin/driver-doc-url/${encodeURIComponent(s3Key)}`);
        return typeof res.data.signedUrl === "string" ? res.data.signedUrl : "";
    } catch (err) {
        return "";
    }
};

